import { OnInit, Component, AfterViewChecked } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService } from "primeng/primeng";
import { MessageService } from "primeng/components/common/messageservice";

import { WebPage } from "../../shared/web-page";
import { Perfis } from '../../../models/perfis';
import { Indicacao } from "../../../models/indicacao.model";
import { AuthService } from '../../admin/auth.service';
import { EmpresaService } from "../../../services/empresa.service";
import { Util } from "../../shared/util";

@Component({
  templateUrl: './gerenciar-indicacao.component.html'
})

export class GerenciarIndicacaoComponent extends WebPage implements OnInit, AfterViewChecked {

  isLoading: boolean =false;
  usuario: any = {};
  perfis: any = {};
  
  form: FormGroup = {} as FormGroup;
  listaIndicacoes: Array<Indicacao> = [];
  registroModal: Indicacao = null;

  hoje = new Date().toISOString().split('T')[0];

  public inputCpf: string;
  public inputNome: string;

  constructor(
    private _router: Router,
    messageService: MessageService,
    private fb: FormBuilder,
    private authService: AuthService,
    private _empresaService: EmpresaService,
    private confirmationService: ConfirmationService,
  ){
      super(messageService);
  }
  
  ngAfterViewChecked(): void {
    //throw new Error("Method not implemented.");
  }
  ngOnInit() {
    this.isLoading = true;
    this.usuario = this.authService.informacoesUsuario();
    this.perfis = Perfis;
    this.criarForm();
    this.pesquisar();
  }

    private criarForm() {
      this.form = this.fb.group({
        cpf: [''],
        nome: [''],
      });
    }

    pesquisar() {
      this.isLoading = true;
      this.messageService.clear();
      const pesquisa = this.montarObjetoPesquisa();

      this._empresaService.getIndicacaoByAll(pesquisa, null)
      .finally( 
        () => { this.isLoading = false;}
      )
      .subscribe(
        (v)=>{
          console.log(v);
          this.listaIndicacoes = v;
        },
        (error) => {
        this.isLoading = false;
        this.gerenciaErro(error)
      });
    }

    montarObjetoPesquisa(): string{
      function isEmptyReturnNull(value: any){
        if(value === null ||value === '') {
          return null;
        }
        return value;
      }
      
      let dado = '';
      if(isEmptyReturnNull(this.form.get('cpf').value)){
        dado = this.form.get('cpf').value;
      }else if(isEmptyReturnNull(this.form.get('nome').value)){
        dado = this.form.get('nome').value;
      }        
      return dado;
    }

    abrirModalDetalhes(registroSelecionado : any) {
      if(registroSelecionado){
        this.registroModal = registroSelecionado;
        this.inputCpf = this.registroModal.cpf;
        this.inputNome = this.registroModal.nome;
      }else{
        this.registroModal = null;
        this.limparDados();
      }
    }
    salvarIndicacao(){
      if(this.registroModal != null){
        this.isLoading = true;
        this.registroModal.cpf = this.inputCpf;
        this.registroModal.nome = this.inputNome;
        this._empresaService.updateIndicacao(this.registroModal,'').finally(
          () => this.isLoading = false
        )
        .subscribe(
          (v) => {
             if(v){
                this.messageService.add(
                  {
                    severity: 'success',
                    summary: 'Salvo',
                    detail: 'Indicação salva com sucesso',
                  }
                )
                this.pesquisar();
              }
          }
        );
      }else{
        this.isLoading = true;
        this.registroModal = {
          idIndicacao: '00000000-0000-0000-0000-000000000000',
          idEmpresa: '37047283-3fb2-4559-9c1c-f7e726e63dea',
          cpf : Util.limpaCpf(this.inputCpf),
          nome : this.inputNome,
          ativo: true,
          dataCadastro: null,
          empresa: null,
        }    
        this._empresaService.inserirIndicacao(this.registroModal).finally(
          () => this.isLoading = false
        )
        .subscribe(
          (v) => {
             if(v){
                this.messageService.add(
                  {
                    severity: 'success',
                    summary: 'Salvo',
                    detail: 'Indicação salva com sucesso',
                  }
                )
                this.pesquisar();
                this.limparDados();
              }
          }
        );
      }
    }
    removerIndicacao(registroSelecionado : Indicacao){
      this.confirmationService.confirm({
        message: 'Deseja remover a indicação?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.isLoading = true;
          this._empresaService.removerIndicacaoByCpf(registroSelecionado.cpf)
          .finally(
            () => this.isLoading = false )
          .subscribe(
            (v) => {
              if(v){
                this.messageService.add(
                  {
                    severity: 'success',
                    summary: 'Removido',
                    detail: 'Indicação removida com sucesso',
                  }
                )
                this.pesquisar();
              }
            },
            (error) => {
              this.gerenciaErro(error);
            }
          );
        }
      });
    }
    limparDados(){
      this.inputCpf = "";
      this.inputNome = "";
      this.registroModal = null;
    }
    voltar() {
      this._router.navigate(['/gerenciar-vagas']);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/vaga/indicacao/gerenciar-indicacao.component.ts